import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise } from 'axios'
import { cookRequestParams } from '@/common/request'
import type {
  TemplateListSearch,
  FragmentListSearch,
  TemplateAuditParams,
  TemplateStatusParams,
  UpdateTemplateParams,
} from './type'

// 片段列表
export function getFragmentList(params: FragmentListSearch): AxiosPromise {
  return request({
    url: `${v2Host}/veditor/template/fragment-list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 片段标签
export function getFragmentTags(): AxiosPromise {
  return request({
    url: `${v2Host}/veditor/template/fragment-tags`,
    method: 'get',
  })
}

// 模版列表
export function getTemplateList(params: TemplateListSearch): AxiosPromise {
  return request({
    url: `${v2Host}/veditor/template/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 模版、片段审核通过、拒绝
export function templateAudit(data: TemplateAuditParams): AxiosPromise {
  return request({
    url: `${v2Host}/veditor/template/audit`,
    method: 'post',
    data,
  })
}

// 模版、片段上下架
export function templateStatus(data: TemplateStatusParams): AxiosPromise {
  return request({
    url: `${v2Host}/veditor/template/status`,
    method: 'post',
    data,
  })
}

// 模版编辑
export function updateTemplate(data: UpdateTemplateParams): AxiosPromise {
  return request({
    url: `${v2Host}/veditor/template/update`,
    method: 'post',
    data,
  })
}

// 片段编辑
export function updateFragment(data: UpdateTemplateParams): AxiosPromise {
  return request({
    url: `${v2Host}/veditor/template/update-fragment`,
    method: 'post',
    data,
  })
}
